// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro_intro__kFqIh","text":"Intro_text__9KWAw"};